module.exports = {
  endpoint: (() => {
    // Replace port of dashboard with 8082
    var url = new URL(window.location.origin)
    url.port = 8082
    return url.toString()
  })(),
  // endpoint: 'https://zadig.intelistyle.co.uk:8082',
  analyticsEndpoint: 'https://lanecrawford.intelistyle.co.uk:8081',

  openAISecretKey: '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',

  s3url: 'https://s3-eu-west-1.amazonaws.com/stylr-ai-engine-srv-data/srv/data/serving/',
  pages: {
    productRanking: true,
    similarResults: true,
    outfitResults: true,
    search: true,
    chatbotProductSelection: true
  },
  chatbotProductSelectionUserId: ''
}
